import { createContext, useContext } from 'react';
const OptionListContext = createContext({});
export const useOptionList = () => useContext(OptionListContext);
export const OptionListProvider = OptionListContext.Provider;
//# sourceMappingURL=useOptionList.js.map